import { render } from "./index.vue?vue&type=template&id=20ecde34&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=20ecde34&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/nonbid_zlysz_com_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ecde34"]])

export default __exports__